import * as React from "react";
import { Typography, Box, Button } from "../../components/mui";
import { DashboardRoundedIcon } from "../../components/icons";
import PageLayout from "../../components/shared/PageLayout";
import "../../styles/main.css";
import "../../styles/pages/underConstruction.css";

/**
 * Under Construction Page Component
 * Shared page for features that are not yet implemented
 * 
 * Props:
 * - pageName: Name of the page being built (e.g., "View Condo Occupancy")
 * - onLogout: Function to handle logout
 * - onNavigate: Function to handle navigation
 */
export default function UnderConstruction({ 
  pageName = "This Page",
  onLogout, 
  onNavigate 
}) {
  return (
    <PageLayout 
      activeKey="under-construction" 
      onLogout={onLogout} 
      onNavigate={onNavigate}
      className="page-content"
    >
      <Box className="under-construction-container">
        <Box className="under-construction-content">
          {/* Icon */}
          <Box className="under-construction-icon">
            🚧
          </Box>

          {/* Title */}
          <Typography variant="h4" className="under-construction-title">
            {pageName}
          </Typography>

          {/* Subtitle */}
          <Typography variant="h6" className="under-construction-subtitle">
            Under Construction
          </Typography>

          {/* Message */}
          <Typography variant="body1" className="under-construction-message">
            We're working hard to bring you this feature. 
            <br />
            Please check back soon!
          </Typography>

          {/* Back to Dashboard Button */}
          <Button 
            variant="contained" 
            startIcon={<DashboardRoundedIcon />}
            onClick={() => onNavigate({ key: 'dashboard' })}
            className="under-construction-button"
          >
            Back to Dashboard
          </Button>
        </Box>
      </Box>
    </PageLayout>
  );
}
